<template>
    <div class="main">
        <!-- 搜索及筛选 -->
        <div class="whiteBg main-top" style="width: 100%; height: 100%;">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">用户上传音频数量限制：</div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <!-- <div class="box box-align-center mt-input" style="margin:  20px 10px;">
                        <div class="mti-txt" style="font-size: 15px; font-weight: 500;">数量：</div>
                        <el-input v-model="maxNum" placeholder="请输入最大数量" clearable></el-input>
                        <div class="mti-txt" style="font-size: 15px; font-weight: 500; margin-left: 5px;">个</div>
                    </div> -->
                    <el-form  ref="ruleForm" :model="ruleForm" :rules="rules" style="margin: 20px;" label-position="right">
                        <el-form-item label="数量：" prop="maxNum">
                            <el-input v-model="ruleForm.maxNum" placeholder="请输入最大数量"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <div class="box box-align-center mt-btns" style="margin: 20px 10px;">
                        <el-button plain icon="el-icon-refresh" @click="resetList">取消</el-button>
                        <el-button type="primary" icon="el-icon-search" @click="submitNum(ruleForm)">提交</el-button>
                    </div>
                </el-col>

            </el-row>
        </div>




    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'

import ExportMoreFile from '@/components/common/exportMoreFile'
import { returnUploadNum, uploadNum } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { formatDate } from '@/utils/utils';
import { sensitiveType } from '@/utils/commonData';

var that = null;
export default {
    data() {
        const { doEdit } = this;
        const { doDelete } = this;
        return {
            dialogTitle: '新建敏感词',
            tableLoading: true,
            columns: [
                {
                    type: 'index',
                    title: '序号'
                },
                {
                    key: 'id',
                    title: '敏感词ID'
                },
                {
                    key: 'words',
                    title: '敏感词名称'
                },
                {
                    key: 'updateAt',
                    title: '更新时间'
                },
                {
                    key: '',
                    title: '操作',
                    render: ({ row }) => {
                        return (
                            <div>
                                <el-link type="danger" style="margin-left:12px" onClick={() => doDelete(row)}>删除</el-link>
                            </div>
                        );
                    }
                },
            ],
            tableData: [],
            
            pageNum: 1,
            pageSize: 10,
            total: 0,
            addVisible: false,
            value: '',
            sensitiveType,
            words: '',
            ruleForm: {
                maxNum:'',
            },
            rules: {
                maxNum: [{ required: true, message: '请输入用户上传音频数量', trigger: 'blur' }],
                // type: [{ required: true, message: '请选择敏感词类型', trigger: 'change' }],
            },
            artName: '',
            addExportVisible: false,
            tHeader: ['敏感词', '敏感词类型(0:政治;1:暴力;2:低俗;3:违法)'],
            tValue: ['words', 'type'],
        }
    },
    components: {
        DyTable,
        ExportMoreFile
    },
    mounted() {
        //测试
        that = this;
        that.getList();
    },
    methods: {

        //提交
        submitNum(ruleForm) {
            var that = this;
            that.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    that.$confirm('确认修改用户最大上传视频数吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let info = {
                            value:that.ruleForm.maxNum
                            
                        };
                        console.log(info);
                        // var data = encrypt(JSON.stringify(info));
                        var data = info;
                        uploadNum(data).then((res) => {
                            that.getList();
                        });
                    })
                } else {
                            console.log('error submit!!');
                            return false;
                        }
                });
        },

 

        //重置列表
        resetList() {
            that.ruleForm.maxNum = '';

            that.getList();
        },
        onCurrentChange(val) {
            this.pageNum = val
            this.getList();
        },
        getList() {
            that.tableLoading = true;
            let info = {
            };
            console.log(info);
            var data = info;
            returnUploadNum(data).then((res) => {
                if (res.result == 1) {
                    var ress = res.data;
                    console.log('上传数量', ress);

                    that.ruleForm.maxNum = ress.value
                    that.tableLoading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
/deep/.el-tabs__item {
    min-width: 100px;
    text-align: center;
    padding: 0;
}

/deep/.el-dropdown {
    margin-right: 10px;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    display: flex;
    white-space: nowrap;
}

// /deep/.el-tabs__header {
//     margin: 0;
// }

.main-top {
    padding: 20px 20px;
    // border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

    .mti-txt {
        white-space: nowrap;
        font-size: 20px;
        font-weight: 600;
    }
}

.main-middle {
    padding: 15px 11px;
}

.common-btns {
    padding: 0 22px 33px;
}
</style>